export default "__VITE_PUBLIC_ASSET__5708d88c__"